import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/renew.png'
import _imports_1 from '@/assets/image/icon/eye-jin.png'


const _withScopeId = n => (_pushScopeId("data-v-4db492a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-swipe" }
const _hoisted_2 = { class: "banner-box" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "list-box" }
const _hoisted_5 = { class: "video-box" }
const _hoisted_6 = { class: "course-tit" }
const _hoisted_7 = { class: "course-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "course-icon-eye",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "course-count" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "course-icon-clicks",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "course-clicks" }
const _hoisted_12 = { class: "video-box" }

import { reactive, onMounted } from 'vue'
import { COURSE_TYPE } from '@/constant/video'
import { getHomeBanner } from '@/api/home'
import {
  getZcjSmallVideoList,
  getZcjSmallVideoType,
  getCurriculum,
  getAllClassRoomType,
} from '@/api/video'
import MTabbar from '@/components/MTabbar/MTabbar.vue'
import { Tab, Tabs, List, Swipe, SwipeItem } from 'vant'
import VideoListCard from './components/VideoListCard.vue'
import MImage from '@/components/MImage/MImage.vue'
import FooterTips from '@/views/components/FooterTips/FooterTips.vue'
import { useRoute } from 'vue-router'
import { VIDEO_TAB_TYPE } from '@/constant/video'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoList',
  setup(__props) {

const route: any = useRoute()
const router: any = useRouter()
const fromName = route.meta?.from?.name

const state = reactive({
  active: route.params.tab || fromName === 'video-detail' ? 2 : 0,
  banner: [],
  videoTypeList: [],
  videoActiveType: Number(location.hash.split('#')[1] || 0),
  videoList: [],
  videoFinished: true,
  videoLoading: false,
  courseActiveType: Number(location.hash.split('#')[1] || 0),
  courseList: [],
  courseLoading: false,
  courseFinished: true,
  pageNum: 1,
  courseTypeList: [],
  videoTypeId: Number(location.hash.split('#')[1] || 1),
})

onMounted(async () => {
  state.pageNum = 0
  const typeList = await getAllClassRoomType()
  const dataList = typeList?.dataList?.map((i) => ({
    ...i,
    label: i.typeName,
    value: i.id,
  }))
  state.courseTypeList = [...COURSE_TYPE, ...dataList]
  const banner = await getHomeBanner({
    advertisementType:
      fromName === 'video-detail' || route.params.tab === '2' ? 6 : 4,
  })
  state.banner = banner?.dataList || []
  const data = await getZcjSmallVideoType({})
  state.videoTypeList = [{ id: -1, smallVideoType: '推荐' }, ...data.dataList]
  onLoadCourse()
  onLoadVideo()
})

const getClickNumber = function (s: number) {
  if (s >= 1e4) return parseInt(s / 1e4) + 'W'
  return s
}

const onLoadCourse = async () => {
  const curriculumType =
    state.courseTypeList[state.courseActiveType]?.value ?? null
  if (curriculumType === null) return false
  // 首页推荐
  if (curriculumType === -1) {
    const { ret, data } = await getCurriculum({
      firstLevel: 2,
    })
    if (ret === 100) {
      state.courseList = data.list
      state.courseFinished = true
      state.courseLoading = true
    }
  } else {
    const { ret, data } = await getCurriculum({
      curriculumType,
      pageNum: state.pageNum++,
    })
    if (ret === 100) {
      state.courseList = data.list
      state.courseFinished = data.isLastPage || data.list.length < data.pageSize
      state.courseLoading = true
    }
  }
}

const onLoadVideo = async () => {
  let params = { pageNum: state.pageNum, type: 1 }
  const activeVideoType = state.videoTypeList[state.videoActiveType] || {
    id: -1,
    smallVideoType: '推荐',
  }
  state.videoTypeId = activeVideoType.id
  if (activeVideoType.id === -1 && state.active === 2) {
    params = { recommendState: 1, pageNum: state.pageNum++, type: 1 }
  } else {
    console.log(state.videoTypeList)
    params = {
      smallVideoTypeId: activeVideoType.id,
      pageNum: state.pageNum++,
      type: 1,
    }
  }
  state.loading = true
  const { ret, data } = await getZcjSmallVideoList(params)
  if (ret === 100) {
    state.videoList = [...state.videoList, ...data.list]
  }
  state.videoFinished = data.isLastPage || data.list.length < data.pageSize
  state.videoLoading = false
}

const handleClickCourseTab = ({ name }) => {
  state.pageNum = 1
  state.courseFinished = false
  state.courseList = []
  onLoadCourse()
}

const handleClickVideoTab = ({ name }) => {
  state.pageNum = 1
  state.videoFinished = false
  state.videoList = []
  onLoadVideo()
}

const handleClickTabType = async () => {
  let value = null
  state.pageNum = 1
  state.courseFinished = false
  state.videoFinished = false
  state.courseList = []
  state.videoList = []
  switch (state.active) {
    case 0:
      value = 4
      onLoadCourse()
      break
    case 2:
      value = 6
      onLoadVideo()
      break
    case 1:
      router.push('/video/chosen')
      state.active = 2
  }
  if (value) {
    const banner = await getHomeBanner({ advertisementType: value })
    state.banner = banner?.dataList || []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_templete = _resolveComponent("templete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Tabs), {
        active: state.active,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((state.active) = $event)),
        onClickTab: handleClickTabType
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(VIDEO_TAB_TYPE), (item, index) => {
            return (_openBlock(), _createBlock(_unref(Tab), {
              title: item.label,
              key: 'tab' + index
            }, null, 8, ["title"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Swipe), {
        class: "header-swipe",
        autoplay: 3000
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.banner, (item) => {
            return (_openBlock(), _createBlock(_unref(SwipeItem), { key: item }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: item.linkUrl
                }, [
                  _createVNode(MImage, {
                    src: item.imgUrl
                  }, null, 8, ["src"])
                ], 8, _hoisted_3)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (state.active === 0)
        ? (_openBlock(), _createBlock(_component_templete, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(Tabs), {
                class: "tabs-skin-rect",
                active: state.courseActiveType,
                "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((state.courseActiveType) = $event)),
                shrink: "",
                onClickTab: handleClickCourseTab
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.courseTypeList, (item) => {
                    return (_openBlock(), _createBlock(_unref(Tab), {
                      title: item.label,
                      key: 'tab' + item.id
                    }, null, 8, ["title"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["active"]),
              _createVNode(_unref(List), {
                loading: state.courseLoading,
                "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((state.courseLoading) = $event)),
                finished: state.courseFinished,
                onLoad: onLoadCourse
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.courseList, (item) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        class: "video-item",
                        key: 'video' + item.id,
                        to: `/video/course-detail/${item.id}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(MImage, {
                            class: "course-cover",
                            src: item.coverImg,
                            alt: ""
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(item.curriculumName), 1),
                          _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("span", _hoisted_9, "更新" + _toDisplayString(item.sumClassHourCount) + "期", 1),
                            _hoisted_10,
                            _createElementVNode("span", _hoisted_11, _toDisplayString(getClickNumber(item.clicks)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["loading", "finished"]),
              (state.courseFinished)
                ? (_openBlock(), _createBlock(FooterTips, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(Tabs), {
              class: "tabs-skin-rect",
              active: state.videoActiveType,
              "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((state.videoActiveType) = $event)),
              shrink: "",
              onClickTab: handleClickVideoTab
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.videoTypeList, (item) => {
                  return (_openBlock(), _createBlock(_unref(Tab), {
                    title: item.smallVideoType,
                    key: 'video_tab' + item.id
                  }, null, 8, ["title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active"]),
            _createVNode(_unref(List), {
              loading: state.videoLoading,
              "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((state.videoLoading) = $event)),
              finished: state.videoFinished,
              onLoad: onLoadVideo
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.videoList, (item) => {
                    return (_openBlock(), _createBlock(VideoListCard, {
                      key: 'video' + item.id,
                      data: item,
                      type: state.videoTypeId
                    }, null, 8, ["data", "type"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"]),
            (state.videoFinished)
              ? (_openBlock(), _createBlock(FooterTips, { key: 0 }))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _createVNode(MTabbar)
  ]))
}
}

})